import { atom } from 'jotai';

export const themeState = atom<string | undefined>('light');
